import { getEntityTypeOptionsByKeyword } from 'app/admin/services/ChangeLogPartnerServices';
import withInputErrorMessage from '../withInputErrorMessage';
import remoteOptionSelectFactory from './remoteOptionSelectFactory';
import withSelectFormik from './withSelectFormik';

export const EntityNameSelectBase = remoteOptionSelectFactory({
   getSuggestionsPromise: getEntityTypeOptionsByKeyword,
});
export default withSelectFormik(withInputErrorMessage(EntityNameSelectBase));
